import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { ISyncDataExportFile } from 'app/core/typings/ISyncDataExportFile';
import { ISyncDataImportFile } from 'app/core/typings/ISyncDataImportFile';
import { PagerService } from 'app/shared/services/pager.service';

@Component({
  selector: 'biz-import-history-table',
  templateUrl: './import-history-table.component.html',
  styleUrls: ['./import-history-table.component.scss']
})
export class ImportHistoryTableComponent implements OnInit {

  public pageSize: number;
  public currentPage: number;
  public historyPaginated: Array<any> = [];
  public _history: ISyncDataExportFile[];

  constructor(private _pagerService: PagerService,
    private ref: ChangeDetectorRef) {
    this._history = [];
    this.pageSize = 5;
  }

  ngOnInit() {
  }

  @Input() public set history(history: ISyncDataImportFile[]) {
    if (history && history.length > 0) {
      this._history = history;
      const begin = !this.currentPage ? 0 : this.currentPage;
      const end = begin ? begin + 1 : 1;
      this.historyPaginated = this._history.slice(this.pageSize * begin, this.pageSize * end);
      this.ref.detectChanges();
    }
  }

  onPaginationEvent(event) {
    const pager = this._pagerService.getPager(this._history.length, event.pageIndex + 1, event.pageSize);
    this.historyPaginated = this._history.slice(pager.startIndex, pager.endIndex + 1);
    this.currentPage = event.pageIndex;
  }
}
